export const HAS_ERROR_CATCH = 'HAS_ERROR_CATCH';
